import React from 'react';
import { Image } from '../../../components/UI';
import { mainContainer } from './styles';
import image from '../../../assets/images/error-bg.jpg';
import { jsx as ___EmotionJSX } from "@emotion/react";

var NotFound = function NotFound() {
  return ___EmotionJSX("div", {
    css: mainContainer
  }, ___EmotionJSX(Image, {
    src: image,
    alt: "404 page",
    width: "600px"
  }));
};

export default NotFound;